import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSideBarfilesActions,
  setPerformanceChildDeleteAction,
  setPerformanceDeleteAction,
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import "../../../StyleSheet/MainComponent/Performance/Performance.scss";
import PerformanceTable from "./PerformanceTable";
import PerformancePopup from "./PerformancePopup";
import PerformanceChildTable from "./PerformanceChildTable";
import PerformanceChildPopup from "./PerformanceChildPopup";
import Delete from "../../AppComponent/Popup/Delete";
import { useNavigate } from "react-router-dom";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";

const PerformanceChild = () => {
  const dispatch = useDispatch();
  const [createEditPopup, setCreateEditPopup] = useState(false);
  const [editPayload, setEditPayload] = useState({});
  const [deleteID, setDeleteID] = useState("");
  const [DeletePopup, setDeletepopup] = useState(false);
  const navigate = useNavigate();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [SearchChild, setSetSearchChild] = useState();

  const [pageNum, setPageNu] = useState();
  const dtpageindex = (dtpageindex) => {
    setPageNu(dtpageindex);
  };

  const performanceData = useSelector(
    (state) => state.performanceChildTypeCall.performanceChildDatas
  );
  const selectedPerformanceParentId = useSelector(
    (state) => state.performanceTypeCall.selectedPerformerData
  );

  const searchchanges = (e) => {
    setSetSearchChild(e);
  };

  const originState = useSelector((originState) => originState);
  useEffect(() => {
    console.log(performanceData, "perforalaskjdflasj");
  }, [performanceData]);
  useEffect(() => {
    {
      Object.keys(editPayload).length > 0 && setCreateEditPopup(true);
    }
  }, [editPayload]);
  // useEffect(() => {
  //   if (deleteID.length > 0) {
  //     console.log("This is coolldfklsdkf");
  //     dispatch(setPerformanceChildDeleteAction(deleteID));
  //   }
  // }, [deleteID]);

  const HandelDelete = () => {
    if (deleteID.length > 0) {
      const payload = {
        DeleteID: deleteID,
        page: pageNum,
        page_size: 10,
        id: originState.performanceTypeCall.selectedPerformerData.id,
      };

      // What Is The Alarm Limit For Wt & Ot In A Transformer?

      // What Type Of Cooling Used In Your Transformer?
      dispatch(setPerformanceChildDeleteAction(payload));
      setDeletepopup(false);
      
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Criteria Type</h3>

          </div>

          <div className="Add-User col-sm-5">
            <button
              onClick={() => {
                setCreateEditPopup(true);
              }}
              className="ButtonCSS"
            >
              Create
            </button>
          </div>
        </div>

        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/performance");
              }}
            >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>

            </button>
          </div>
        </div>

        <PerformanceChildTable
          performanceData={performanceData}
          setCreateEditPopup={setCreateEditPopup}
          setEditPayload={setEditPayload}
          setDeleteID={setDeleteID}
          dtpageindex={dtpageindex}
          setDeletepopup={setDeletepopup}
          searchchanges={searchchanges}
        />
      </div>
      <PerformanceChildPopup
        show={createEditPopup}
        setShow={setCreateEditPopup}
        editPayload={editPayload}
        setEditPayload={setEditPayload}
        selectedPerformanceParentId={selectedPerformanceParentId}
        search={SearchChild}
      />
      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletepopup}
          onSubmit={HandelDelete}
          Content={"Do you want to delete the Criteria Type"}

        />
      ) : null}
    </>
  );
};

export default PerformanceChild;
